import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import dayjs from "dayjs";
import {
  FormControl,
  Select,
  MenuItem,
  Grid,
  Box,
  Paper,
  Container,
  Popper,
  Typography,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

import CardStyle from "../../shared/general/Card";
import ButtonBlue from "../../shared/general/ButtonBlue";
import {
  getDocumentGroupName,
  getDocumentTypeName,
} from "../../../../actions/document";
import DialogType from "./dialogType";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "120px",
    marginBottom: "120px",
  },
  pageTitle: {
    color: "#16243D",
    fontSize: "1.5rem",
    fontWeight: 600,
  },
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(4),
    borderRadius: "20px",
    boxShadow: "rgb(90 114 123 / 11%) 0px 7px 30px 0px",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  },
  description: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    marginBottom: theme.spacing(3),
  },
  button_container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  button: {
    borderColor: "#007afe",
    color: "#ffffff",
    backgroundColor: "#007afe",
    borderRadius: 8,
    "&:hover": {
      borderColor: "#0046b7",
      backgroundColor: "#0046b7",
    },
  },
}));
const StyledRoot = styled(Box)({
  backgroundColor: "#FFFFFF !important",
});
const StyledBox = styled(Box)({
  "&.open": {
    paddingLeft: 16,
    width: "calc(100% - 1000px)",
  },
  "&.close": {
    paddingLeft: 0,
    width: "100%",
  },
});

const StyledCellHeader = styled(TableCell)({
  borderBottom: "1px dashed rgba(224, 224, 224, 1)",
  color: "#637381",
  backgroundColor: "#f4f6f8",
  "& .MuiTypography-root": {
    color: "#637381",
    backgroundColor: "#f4f6f8",
    "&.weekend": {
      fontStyle: "oblique",
    },
    "&.workday": {
      fontWeight: 600,
    },
  },
  "&.sticky": {
    padding: 0,
    position: "sticky",
    left: 0,
    zIndex: 4,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    boxShadow: "20px 0px 20px #EEEEEE",
    "& .MuiTableCell-root": {
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
    },
  },
  "&:last-of-type": {
    paddingRight: 24,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
  },
});

const StyledRowContent = styled(TableRow)({
  cursor: "pointer",
  textDecoration: "none",
  "&.MuiTableRow-hover:hover": {
    backgroundColor: "#f7f7f7",
    "& .sticky": {
      backgroundColor: "#f7f7f7",
    },
  },
});

const StyledCellContent = styled(TableCell)(({ theme }) => ({
  borderBottom: "opx",
  padding: 8,
  "&.sticky": {
    position: "sticky",
    left: 0,
    backgroundColor: "#FFFFFF",
    boxShadow: "8px 20px 20px #EEEEEE",
  },
  "& .avatar": {
    minWidth: 240,
    "& .MuiAvatar-root": {
      marginRight: 8,
    },
    display: "flex",
    alignItems: "center",
  },
  "& .fullname": {
    fontWeight: 600,
  },
  "& .position": {
    color: theme.palette.text.secondary,
    fontSize: 14,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: 300,
  },
  "& .secondaryAction": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& .location": {
      fontWeight: 600,
    },
  },
  "&:first-of-type": {
    paddingLeft: 0,
  },
  "&:last-of-type": {
    paddingRight: 24,
  },
}));
const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  marginTop: 24,
  "& .MuiToggleButtonGroup-grouped": {
    margin: theme.spacing(0.5),
    color: "#46cbe2",
    border: "1px solid #46cbe2",
    backgroundColor: "#FFFFFF",
    "&:hover": {
      borderColor: "#247785",
      backgroundColor: "#247785",
      color: "#FFFFFF",
    },
    "&.Mui-selected": {
      color: "#FFFFFF",
      backgroundColor: "#46cbe2",
      "&:hover": {
        borderColor: "#247785",
        backgroundColor: "#247785",
        color: "#FFFFFF",
      },
    },
    "&.Mui-disabled": {
      border: 0,
    },
    "&:not(:first-of-type)": {
      borderRadius: 8,
      borderLeft: "1px solid #46cbe2",
    },
    "&:first-of-type": {
      borderRadius: 8,
    },
  },
}));
const StyledBoxSearch = styled(Box)({
  marginTop: 22,
  "& .label": {
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 8,
  },
});
// const docGroup = [
//     { idDocumentGroup: 1, documentGroupName: "เอกสารส่วนตัว" },
//     { idDocumentGroup: 2, documentGroupName: "สัญญา" },
//     { idDocumentGroup: 3, documentGroupName: "เอกสารบริษัท" }

// ]
// const docName = [
//     { idDocumentType: 1, documentTypeName: "Offer", idDocumentGroup: 1 },
//     { idDocumentType: 2, documentTypeName: "Employment Eligibility", idDocumentGroup: 1 },
//     { idDocumentType: 3, documentTypeName: "Tax Document", idDocumentGroup: 1 },
//  ]
// const List = ["เอกสารส่วนตัว", "สัญญา", "เอกสารบริษัท", "สวัสดิการ", "เงินเดือน", "อื่นๆ"]

const DialogNewDocument = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [view, setView] = useState(1);
  const [formData, setFormData] = useState(null);
  const [open, setOpen] = useState(false);
  const [typeDialog, setTypeDialog] = useState(null);
  const [reload, setreload] = useState();
  const { result: docGroup } = useSelector((state) => state.documentGroup);
  const { result: docName } = useSelector((state) => state.documentItem);

  const handleChangeView = (event, newView) => {
    if (newView) {
      setView(newView);
    }
  };

  const handleDialog = (type, formData, d) => {
    setTypeDialog(type);
    setOpen(true);
    if (formData) {
      setFormData(formData);
    }
  };

  const handleClose = () => {
    setTypeDialog(null);
    setOpen(false);
    if (reload === 1) setreload(2);
    else setreload(1);
    setFormData(null);
  };

  useEffect(() => {
    dispatch(getDocumentGroupName());
  }, []);

  useEffect(() => {
    dispatch(getDocumentTypeName(view));
  }, [view, reload]);

  return (
    <StyledRoot className="page">
      <Container maxWidth="lg">
        <div
          style={{
            marginBottom: 8,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            className="wrap-search-action"
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <Typography variant="h4" style={{ paddingTop: 8 }}>
              แก้ไขชื่อเอกสาร
            </Typography>
          </div>
          <StyledBoxSearch>
            <div
              className="wrap-search-action"
              style={{ justifyContent: "flex-end" }}
            >
              <div>
                <ButtonBlue
                  variant="contained"
                  startIcon={<FileUploadOutlinedIcon />}
                  onClick={() => handleDialog("Add")}
                >
                  เพิ่มชื่อเอกสาร
                </ButtonBlue>
              </div>
            </div>
          </StyledBoxSearch>
        </div>

        <StyledToggleButtonGroup
          value={view}
          exclusive
          onChange={handleChangeView}
          aria-label="view"
          size="small"
        >
          {docGroup &&
            docGroup.map((v, index) => {
              return (
                <ToggleButton
                  name={index}
                  value={v.idDocumentGroup}
                  size="small"
                  style={{ minWidth: 150, marginRight: 12 }}
                >
                  {v.documentGroupName}
                </ToggleButton>
              );
            })}
        </StyledToggleButtonGroup>

        <StyledRoot>
          <Container maxWidth="lg">
            <CardStyle style={{ marginTop: 8 }}>
              <Box style={{ padding: "24px" }}>
                <Box style={{ display: "flex", position: "relative" }}>
                  <StyledBox className={"close"}>
                    <TableContainer style={{ width: "100%", maxHeight: 600 }}>
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                          <TableRow>
                            <StyledCellHeader
                              align={"center"}
                              className="sticky"
                              style={{ minWidth: 240 }}
                            >
                              ชื่อเอกสาร
                            </StyledCellHeader>
                            <StyledCellHeader>
                              <Typography variant="body2" align="center">
                                แสดงในหน้าแรก
                              </Typography>
                            </StyledCellHeader>
                            <StyledCellHeader>
                              <Typography variant="body2" align="center">
                                รายละเอียด
                              </Typography>
                            </StyledCellHeader>
                            <StyledCellHeader>
                              <Typography variant="body2" align="center">
                                ไฟล์
                              </Typography>
                            </StyledCellHeader>
                            <StyledCellHeader>
                              <Typography variant="body2" align="center">
                                แก้ไข
                              </Typography>
                            </StyledCellHeader>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {docName
                            ? docName.map((row, index) => (
                                <StyledRowContent>
                                  <StyledCellContent
                                    key={`${index}ืname`}
                                    className="sticky"
                                    style={{
                                      borderBottom:
                                        "1px dashed rgba(224, 224, 224, 1)",
                                    }}
                                  >
                                    <Typography className="fullname">
                                      {row.documentTypeName}
                                    </Typography>
                                  </StyledCellContent>
                                  <StyledCellContent
                                    className="sticky"
                                    style={{
                                      borderBottom:
                                        "1px dashed rgba(224, 224, 224, 1)",
                                    }}
                                  >
                                    <div className="flex">
                                      {row.isShow === 1 ? (
                                        <Typography
                                          style={{ padding: 2 }}
                                          variant="body2"
                                          align="center"
                                        >
                                          แสดง
                                        </Typography>
                                      ) : (
                                        <Typography
                                          style={{ padding: 2 }}
                                          variant="body2"
                                          align="center"
                                        >
                                          ไม่แสดง
                                        </Typography>
                                      )}
                                    </div>
                                  </StyledCellContent>
                                  <StyledCellContent
                                    key={`${index}detail`}
                                    className="sticky"
                                    style={{
                                      borderBottom:
                                        "1px dashed rgba(224, 224, 224, 1)",
                                    }}
                                  >
                                    <Typography
                                      className="fullname"
                                      align="center"
                                    >
                                      {row.detail}
                                    </Typography>
                                  </StyledCellContent>
                                  <StyledCellContent
                                    align="center"
                                    className="sticky"
                                    style={{
                                      borderBottom:
                                        "1px dashed rgba(224, 224, 224, 1)",
                                    }}
                                  >
                                    {row.filename ? (
                                      <CheckCircleOutlineIcon
                                        style={{ color: "green" }}
                                        onClick={() => window.open(row.fileURL)}
                                      />
                                    ) : (
                                      <CancelOutlinedIcon
                                        style={{ color: "red" }}
                                      />
                                    )}
                                  </StyledCellContent>
                                  <StyledCellContent
                                    key={`${index}edit`}
                                    className="sticky"
                                    style={{
                                      borderBottom:
                                        "1px dashed rgba(224, 224, 224, 1)",
                                    }}
                                    align="center"
                                  >
                                    {row.idDocumentType == 1 ||
                                    row.idDocumentType == 2 ||
                                    row.idDocumentType == 3 ||
                                    row.idDocumentType == 4 ||
                                    row.idDocumentType == 5 ? (
                                      "-"
                                    ) : (
                                      <EditIcon
                                        onClick={() =>
                                          handleDialog("edit", row)
                                        }
                                      />
                                    )}
                                  </StyledCellContent>
                                </StyledRowContent>
                              ))
                            : "ไม่พบข้อมูล"}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </StyledBox>
                </Box>
              </Box>
            </CardStyle>
          </Container>
        </StyledRoot>
      </Container>
      {open ? (
        <DialogType
          open={open}
          mode={typeDialog}
          data={formData}
          handleClose={handleClose}
        />
      ) : (
        ""
      )}
    </StyledRoot>
  );
};

export default DialogNewDocument;
